import { useMemo } from 'react';
import { calculateSignature } from '../helpers/calculateSignature';
import { useExtractTransformationsFromUrl } from './extractTransformationsFromUrl';

export const useInitialSignature = () => {
  const { transformationName, transformationSignature } = useExtractTransformationsFromUrl();
  return useMemo(() => {
    if (transformationName) {
      return calculateSignature(transformationName);
    }

    return transformationSignature;
  }, [transformationSignature, transformationName]);
};
